export const compress = (image, fileName, width, height, callbackFn) => {
    
    const reader = new FileReader()
    reader.readAsDataURL(image)

    reader.onload = event => {
        let img = new Image()
        img.src = event.target.result

        img.onload = () => {
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')

            // img.width and img.height will give the original dimensions
            ctx.drawImage(img, 0, 0, width, height)
            
            ctx.canvas.toBlob((blob) => {
                const file = new File([blob], fileName, {
                    type: 'image/png',
                    lastModified: Date.now()
                });

                callbackFn(file)

            }, 'image/png', 0.90)
        }
    }

    reader.onerror = error => console.log(error);
}

export const calculateNewSize = (originalWidth, originalHeight, maxWidth, maxHeight) => {

    let width
    let height

    // los tamaños máximos no pueden ser mayores a los originales
    /* los tamaños pueden ser más grandes
    if(originalWidth < maxWidth)
        maxWidth = originalWidth

    if(originalHeight < maxHeight)
        maxHeight = originalHeight
    */

    // calculo de dimensiones 
    if(originalWidth > originalHeight)
    {
        // asigno la propiedad más grande con el tamaño máximo
        width = maxWidth

        // calculo la propiedad más chica respetando el aspecto
        let ratio = originalHeight / originalWidth
        height = width * ratio
    }
    else
    {
        // asigno la propiedad más grande con el tamaño máximo
        height = maxHeight

        // calculo la propiedad más chica respetando el aspecto
        let ratio = originalWidth / originalHeight
        width = height * ratio
    }

    return { width: width, height: height }
}

export function b64ToBlob(img_original){  
    if(!img_original)return null;
    if(img_original.indexOf("blob:")!==-1)return img_original;

    let byteCharacters= atob(img_original);
    let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
    let byteArray = new Uint8Array(byteNumbers);
    return URL.createObjectURL( new Blob ([byteArray] , {type: "image/jpeg"}))
  }

  export function b64ToBlobRaw(img_original){  
    if(!img_original)return null;
    if(img_original.indexOf("blob:")!==-1)return img_original;

    let byteCharacters= atob(img_original);
    let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
    let byteArray = new Uint8Array(byteNumbers);
    return  (new Blob ([byteArray] , {type: "image/jpeg"}))
  }